module.exports = __webpack_public_path__ + "static/img/from3.d13bbc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/from3.jpg
// module id = wAjf
// module chunks = 1